
import {
  registerUserService,
  loginUserService,
  loginWithGoogleService,
  registerWithGoogleService,
  requestPasswordResetService,
} from "./api";
import {
  REGISTER_USER,
  REGISTER_USER_FAILED,
  REGISTER_USER_SUCCESS,
  LOGIN_USER,
  LOGIN_USER_FAILED,
  LOGIN_USER_SUCCESS,

  LOGIN_USER_WITH_GOOGLE,
  LOGIN_USER_WITH_GOOGLE_COMPLETE,

  REGISTER_WITH_GOOGLE,
  REGISTER_WITH_GOOGLE_COMPLETE,

  REQUEST_RESET_PASSWORD,
  REQUEST_RESET_PASSWORD_COMPLETE,

  LOGOUT,
} from "./types";

import ls, { USER_NOR_GET_SHI_SHI } from '../../utils/ls';
import { toast } from 'react-toastify';

export const registerUserAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: REGISTER_USER });
    const response = await registerUserService(params);
    ls.store(USER_NOR_GET_SHI_SHI, JSON.stringify(response?.data))
    dispatch({ type: REGISTER_USER_SUCCESS, user: response?.data });
    toast.success('Sign up Successful')
  } catch (error) {
    dispatch({ type: REGISTER_USER_FAILED });
    toast.error(error.message || 'Something went wrong')
  }
};


export const loginUserAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_USER });
    const response = await loginUserService(params);
    ls.store(USER_NOR_GET_SHI_SHI, JSON.stringify(response?.data));
    dispatch({ type: LOGIN_USER_SUCCESS, user: response?.data });
    toast.success("Login Successful");
  } catch (error) {
    const msg = error?.response?.data?.error || error.message;
    dispatch({ type: LOGIN_USER_FAILED });
    toast.error(msg);
  }
};

export const loginUserWithGoogleAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: LOGIN_USER_WITH_GOOGLE });
    const response = await loginWithGoogleService(params);
    ls.store(USER_NOR_GET_SHI_SHI, JSON.stringify(response?.data));
    dispatch({ type: LOGIN_USER_SUCCESS, user: response?.data });
    dispatch({ type: LOGIN_USER_WITH_GOOGLE_COMPLETE });

    toast.success("Login Successful");
  } catch (error) {
    const msg = error?.response?.data?.error || error?.message;
    dispatch({ type: LOGIN_USER_WITH_GOOGLE_COMPLETE });
    toast.error(msg);
  }
};

export const registerWithGoogleAction = (params) => async (dispatch) => {
  try {
    dispatch({ type: REGISTER_WITH_GOOGLE });
    const response = await registerWithGoogleService(params);
    ls.store(USER_NOR_GET_SHI_SHI, JSON.stringify(response?.data));
    dispatch({ type: REGISTER_USER_SUCCESS, user: response?.data });
    dispatch({ type: REGISTER_WITH_GOOGLE_COMPLETE });
    toast.success("Sign up Successful");
  } catch (error) {
    const msg = error?.response?.data?.error || error?.message;
    dispatch({ type: REGISTER_WITH_GOOGLE_COMPLETE });
    toast.error(msg);
  }
};

export const requestResetPasswordAction = (params) => async (dispatch) => {
try {
  dispatch({type: REQUEST_RESET_PASSWORD })
   await requestPasswordResetService(params);
  dispatch({ type: REQUEST_RESET_PASSWORD_COMPLETE })
  return true;
} catch (error) {
  dispatch({ type: REQUEST_RESET_PASSWORD_COMPLETE })
  toast.error(error?.response?.data?.error || error.msg)
}
}

export const logoutAction = () =>  (dispatch) => {
  try {
  ls.delete(USER_NOR_GET_SHI_SHI)
  dispatch({type: LOGOUT})
  toast.success('Logout Successfully')
  } catch (error) {
  }
}
